import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { configApi } from '../api/config.api';
import type { AmenityConfig } from '../types/config.types';

interface UseAmenitiesOptions {
  venueType?: string;
}

export function useAmenities(
  options?: UseAmenitiesOptions
): UseQueryResult<AmenityConfig[], Error> {
  return useQuery({
    queryKey: ['amenities', options?.venueType],
    queryFn: () => configApi.getAmenities(options),
    staleTime: 5 * 60 * 1000, // 5 minutes - amenities don't change often
  });
}
